import React, { useState } from 'react';
import EquipmentData from './data';
import EquipmentDataView from './data-view';

const EquipmentDataTab = ({info}) => {
    // 'list' 또는 'detail' 상태를 관리
    const [viewMode, setViewMode] = useState('list'); 
    // 상세 페이지에 보여줄 아이템의 ID나 데이터 저장
    const [selectedId, setSelectedId] = useState(null); 
    // 페이지 상태를 목록 컴포넌트가 아닌 부모 컴포넌트에서 관리!
    const [currentPage, setCurrentPage] = useState(0);

    // 목록에서 항목을 클릭했을 때 실행할 함수
    const handleSelectItem = (id) => {
        setSelectedId(id);
        setViewMode('detail'); // 상세 화면으로 전환
    };

    // 상세에서 목록으로 돌아갈 때 실행할 함수
    const handleGoBack = () => {
        setViewMode('list'); // 목록 화면으로 전환
        setSelectedId(null);
    };

    if (!info) return;

    return (
        <div>
        {viewMode === 'list' ? (
            // 1. 목록 화면
            <EquipmentData info={info} currentPage={currentPage} setCurrentPage={setCurrentPage} onSelectItem={handleSelectItem} />
        ) : (
            // 2. 상세 화면
            <EquipmentDataView info={info} selectedId={selectedId} onGoBack={handleGoBack} />
        )}
        </div>
    );
}
export default EquipmentDataTab;